import * as ngCore from '@angular/core'

import * as helpers from '../../helpers'

/**
 * A component that should be provided as ng-content to AtnDsStepperComponent
 *
 * **Slots**
 * - *default* The content of the stepper item
 *
 * **Inputs**
 * - {@link AtnDsStepperItemComponent.id|id} Specifies the identifier of the
 *   HTML element to which this step item is connected. The HTML element should
 *   have a `stepperItem` attribute defined with a value that matches the input
 *   `id` of this component.
 * - {@link AtnDsStepperItemComponent.isActive|isActive} Determines whether the
 *   style of the step item should be altered to reflect its active state.
 *
 * **Outputs**
 * - {@link AtnDsStepperItemComponent.click|click} Handle click event
 *
 * @example
 * ```html
 * <atn-ds-stepper-item [id]='stepperItem1' [isActive]='false'></atn-ds-stepper-item>
 * <atn-ds-section name="Section Name">
 *   <div>Section Content (can be angular component)</div>
 * </atn-ds-section>
 * ```
 */
@ngCore.Component({
  selector: 'atn-ds-stepper-item',
  standalone: true,
  styleUrls: ['./stepper-item.component.scss'],
  templateUrl: './stepper-item.component.html',
})
export class AtnDsStepperItemComponent {
  @ngCore.Input({ required: true })
  public id!: string

  @ngCore.Input()
  public isActive = false

  @ngCore.Output()
  public click = new ngCore.EventEmitter<void>()

  public clickHandler($event: Event): void {
    if (!this.id) {
      throw new Error('Id is not provided for Stepper Item')
    }
    $event.stopPropagation()
    if (this.click.observed) {
      this.click.emit()
    }
    document
      .querySelector(helpers.getStepperItemQuerySelector(this.id))
      ?.scrollIntoView({ behavior: 'smooth' })
  }
}
